
import {Component, Prop, Vue} from "vue-property-decorator";
import {IScreenPay} from "@/modules/ScreenPay/interfaces/screen-pay.interface";

  @Component({})
  export default class SPAdditionalControls extends Vue {
    @Prop() payInfo: IScreenPay.IPayInfo;
    @Prop() carNumber: string;

    async openClaims() {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'barriers',
        dialogName: 'claimsPopup',
        payload: {
          carNumber: this.carNumber,
          tSum: this.payInfo.sum,
        }
      });
    }

    async openCantExit() {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'payment',
        dialogName: 'cantExitPopup',
        payload: {
          carNumber: this.carNumber,
        }
      });
    }
  }
